import { BucketAwtENUM, useUploadFile } from "@/shared";
import { AlertSeverityEnum } from "@/shared/interfaces";
import { useUiStore } from "@/store/ui";
import { useState } from "react";
import { UseFormReturn } from "react-hook-form";

enum KeyImagenEditAgendamiento {
  IDENTIFICACION_DELANTERA = 'IDENTIFICACION_DELANTERA',
  IDENTIFICACION_POSTERIOR = 'IDENTIFICACION_POSTERIOR',
  CUENTA_BANCARIA = 'CUENTA_BANCARIA',
  TARJETA = 'TARJETA',
  RUC = 'RUC',
  NOMBRAMIENTO = 'NOMBRAMIENTO'
}

export const useEditPendienteActualizarFotos = ({
  form
}: {
  form: UseFormReturn<any, any, any>;
}) => {

  ///* TODO: Soluccion temporal
  const [imgCedulaFrontal, setImgCedulaFrontal] = useState<File | null>(null);
  const [imgCedulaReverso, setImgCedulaReverso] = useState<File | null>(null);
  const [imgCuentaBancaria, setCuentaBancaria] = useState<File | null>(null);
  const [imgTarjeta, setImgTarjeta] = useState<File | null>(null);
  const [imgRUC, setImgRUC] = useState<File | null>(null);
  const [imgRUCNombramiento, setImgRUCNombramiento] = useState<File | null>(null);

  const { handleUploadFile } = useUploadFile();
  const setAlert = useUiStore.getState().setAlert;

  ///* handlers --------------------
  const handeleEditImagen = async () => {
    try {
      ///*Actualizar fotos
      const imagenList = [{
        file: imgCedulaFrontal,
        url: form.getValues().url_foto_identificacion_delantera,
        bucket: BucketAwtENUM.IMAGE_IDENTIFICACION,
        key: KeyImagenEditAgendamiento.IDENTIFICACION_DELANTERA
      },
      {
        file: imgCedulaReverso,
        url: form.getValues().url_foto_identificacion_posterior,
        bucket: BucketAwtENUM.IMAGE_IDENTIFICACION,
        key: KeyImagenEditAgendamiento.IDENTIFICACION_POSTERIOR
      },
      {
        file: imgCuentaBancaria,
        url: form.getValues().url_foto_cuenta_bancaria,
        bucket: BucketAwtENUM.IMAGE_CUENTA_BANCARIA,
        key: KeyImagenEditAgendamiento.CUENTA_BANCARIA

      },
      {
        file: imgTarjeta,
        url: form.getValues().url_foto_tarjeta,
        bucket: BucketAwtENUM.IMAGE_TARJETA,
        key: KeyImagenEditAgendamiento.TARJETA
      },
      {
        file: imgRUC,
        url: form.getValues().url_foto_ruc,
        bucket: BucketAwtENUM.IMAGE_IDENTIFICACION,
        key: KeyImagenEditAgendamiento.RUC

      },
      {
        file: imgRUCNombramiento,
        url: form.getValues().url_foto_nombramiento,
        bucket: BucketAwtENUM.IMAGE_IDENTIFICACION,
        key: KeyImagenEditAgendamiento.NOMBRAMIENTO
      }
      ].filter(e => e.file != null);


      let nuevoFile: { url: string, key: string }[] = []

      // Función para procesar cada archivo
      const processFile = async (element: typeof imagenList[0]) => {
        // if (element.file && element.url) {
        //   await handleUpdateFile(element.file, '', element.url, true);
        // } else 
        if (element.file) {
          const resp = await handleUploadFile(element.file, element.bucket);
          nuevoFile.push({ url: resp.url, key: element.key });
        }
      };

      // Procesar todos los archivos en paralelo
      await Promise.all(imagenList.map((element) => processFile(element)));

      if (!nuevoFile.length) return null

      // Función para mapear URLs
      const getUpdatedUrl = (key: string, originalUrl: string) => {
        return nuevoFile.find((e) => e.key === key)?.url ?? originalUrl;
      };

      const dataSend = {
        url_foto_identificacion_delantera: getUpdatedUrl(
          KeyImagenEditAgendamiento.IDENTIFICACION_DELANTERA,
          form.getValues().url_foto_identificacion_delantera
        ),
        url_foto_identificacion_posterior: getUpdatedUrl(
          KeyImagenEditAgendamiento.IDENTIFICACION_POSTERIOR,
          form.getValues().url_foto_identificacion_posterior
        ),
        url_foto_cuenta_bancaria: getUpdatedUrl(
          KeyImagenEditAgendamiento.CUENTA_BANCARIA,
          form.getValues().url_foto_cuenta_bancaria
        ),
        url_foto_tarjeta: getUpdatedUrl(
          KeyImagenEditAgendamiento.TARJETA,
          form.getValues().url_foto_tarjeta
        ),
        url_foto_ruc: getUpdatedUrl(
          KeyImagenEditAgendamiento.RUC,
          form.getValues().url_foto_ruc
        ),
        url_foto_nombramiento: getUpdatedUrl(
          KeyImagenEditAgendamiento.NOMBRAMIENTO,
          form.getValues().url_foto_nombramiento
        ),
      };


      return dataSend

    } catch (error) {
      setAlert(
        true,
        'Ocurrió un problema al cargar las imágenes, por favor, intente nuevamente.',
        AlertSeverityEnum.error,
        5000
      );
    }
  };


  return {
    handeleEditImagen,

    imgCedulaFrontal, setImgCedulaFrontal,
    imgCedulaReverso, setImgCedulaReverso,
    imgCuentaBancaria, setCuentaBancaria,
    imgTarjeta, setImgTarjeta,
    imgRUC, setImgRUC,
    imgRUCNombramiento, setImgRUCNombramiento
  }
}